import axios from 'axios';

class Network {
  static getUrl(route) {
    if (route.indexOf('http://') === 0 || route.indexOf('https://') === 0 || route.indexOf('www.') === 0) {
      return route;
    }
    return `${process.env.REACT_APP_API_HOST}${route}`;
  }

  static basicHeaders(extraHeaders) {
    const headers = {};

    // ONLY USE THIS IF YOU WORK IN A BROWSER
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';

    return { ...headers, ...extraHeaders };
  }

  static errorHandler(error) {
    if (error.response) {
      throw {
        errors: (error.response.data && error.response.data.errors) || [{ code: '0', status: 500, title: 'Unknown error', meta: error.response }],
      };
    } else if (error.request) {
      // The request was made but no response was received
      throw {
        errors: [{ code: '0', status: 500, title: 'Unknown error', meta: error.request }],
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      throw {
        errors: [{ code: '0', status: 500, title: 'Unknown error', meta: error.message }],
      };
    }
  }

  static async get(route, extraHeaders = {}) {
    try {
      const headers = this.basicHeaders(extraHeaders);
      const result = await axios.get(this.getUrl(route), { headers, withCredentials: true });
      return result.data;
    } catch (err) {
      this.errorHandler(err);
    }
  }

  static async put(route, body = {}, extraHeaders = {}) {
    try {
      const headers = this.basicHeaders(extraHeaders);
      const result = await axios.put(this.getUrl(route), body, { headers, withCredentials: true });
      return result.data;
    } catch (err) {
      this.errorHandler(err);
    }
  }

  static async patch(route, body = {}, extraHeaders = {}) {
    try {
      const headers = this.basicHeaders(extraHeaders);
      const result = await axios.patch(this.getUrl(route), body, { headers, withCredentials: true });
      return result.data;
    } catch (err) {
      this.errorHandler(err);
    }
  }

  static async post(route, body = {}, extraHeaders = {}) {
    try {
      const headers = this.basicHeaders(extraHeaders);
      const result = await axios.post(this.getUrl(route), body, { headers, withCredentials: true });
      return result.data;
    } catch (err) {
      this.errorHandler(err);
    }
  }

  static async delete(route, extraHeaders = {}) {
    try {
      const headers = this.basicHeaders(extraHeaders);
      const result = await axios.delete(this.getUrl(route), { headers, withCredentials: true });
      return result.data || true;
    } catch (err) {
      this.errorHandler(err);
    }
  }
}

export default Network;

